import { memo, useCallback } from 'react';

import { Text, Image, Box } from '@betty/moonlight';

import { BigWins } from './BigWinsSection.constants';
import styles from './BigWinsSection.module.css';

import { StackNavigationProp, useNavigation } from '@betty/navigation';
import { Pressable } from 'react-native';

function BigWinsSection() {
  const navigation =
    useNavigation<StackNavigationProp<AppNavigatorParamsList>>();

  const handlePress = useCallback((name: string) => {
    navigation.navigate('GameInfoScreen', { name });
  }, [navigation]);

  return (
    <section className={styles.bigWinSection}>
      <Text variant="h4" gradient="darkSurfaceAccent">
        Big wins all around
      </Text>
      <Text variant="body-m" color="darkSurfacePrimary">
        We’re all about great gameplay, exciting rewards, and celebrating
        Ontario’s biggest Betty moments.
      </Text>
      <Box position="relative"
        flexDirection={{
          desktop: 'row',
          tablet: 'row',
          mobile: 'column',
        }}
        flexWrap="nowrap"
        gap="space-400"
        justifyContent="center"
      >
        {BigWins.map((bigWin) => (
          <div key={bigWin.imgSrc} className={styles.bigWinCard}>
            <div className={styles.infoHref}>
              <Pressable onPress={() => handlePress(bigWin.name)}>
                <Image
                  name={bigWin.imgSrc}
                  maxHeight={{
                    desktop: 228,
                    tablet: 228,
                    mobile: 96,
                  }}
                  maxWidth={{
                    desktop: 228,
                    tablet: 228,
                    mobile: 96,
                  }}
                  width={
                    {
                      desktop: "100%",
                      tablet: "100%",
                      mobile: 96,
                    }
                  }
                  height={
                    {
                      desktop: "100%",
                      tablet: "100%",
                      mobile: 96,
                    }
                  }
                  aspectRatio={1}
                  borderRadius="radius-400"
                  marginHorizontal='auto'
                  />
                </Pressable>
            </div>
            <div className={styles.bigWinCardContent}>
              <Text
                variant="h5"
                color="darkSurfacePrimary"
                marginHorizontal={{
                  desktop: 'auto',
                  tablet: 'auto',
                  mobile: undefined,
                }}
              >
                {bigWin.prize}
              </Text>
              <Text
                variant="body-s"
                color="darkSurfaceMuted"
                textAlign={{
                  desktop: 'center',
                  tablet: 'center',
                  mobile: 'left',
                }}
                marginHorizontal={{
                  desktop: 'auto',
                  tablet: 'auto',
                  mobile: undefined,
                }}
                width={{
                  desktop: undefined,
                  tablet: undefined,
                  mobile: 125,
                }}
              >
                {bigWin.city}
              </Text>
              <Text
                variant="body-s"
                color="darkSurfaceMuted"
                textAlign={{
                  desktop: 'center',
                  tablet: 'center',
                  mobile: 'left',
                }}
                marginHorizontal={{
                  desktop: 'auto',
                  tablet: 'auto',
                  mobile: undefined,
                }}
                width={{
                  desktop: undefined,
                  tablet: undefined,
                  mobile: 125,
                }}
              >
                {bigWin.date}
              </Text>
            </div>
          </div>
        ))}
      </Box>
    </section>
  );
}

export default memo(BigWinsSection);
